import React, { useContext } from 'react';
import { FormContext } from 'contexts/FormContext';
import {
  ApplicationName,
  FormNavigation} from 'components/CASAForm';
import {
  AuFormItemWrapper,
  AuDirectionLink
} from 'components/DTA';
import { ArnApplicationDvsMethodFormData } from 'types/forms/arnApplicationTypes';
import { useFormikContext } from 'formik';

const ManualPOIInformation: React.FC = (props: any) => {
  useFormikContext<ArnApplicationDvsMethodFormData>();
  const { handleBack, setFormAlert, openStepById } = useContext(FormContext);
  const { nextStep } = props;

  const handleNext = async () => {
    setFormAlert(null);
    openStepById(nextStep);
  };

  return (
    <>
      <ApplicationName name='Manual verification' />
      <AuDirectionLink
        onClick={handleBack}
        text="Back"
        direction="left" />
      <AuFormItemWrapper>
        <h3>What you&apos;ll need to achieve 100 points of ID</h3>
        <p>Different types of identity documents are worth points. You can use different combinations of documents to make up your 100 points.</p>
        <p>
          <img src='/forms/images/manual-poi-verification.svg' style={{ width: '100%' }}/>
        </p>
        <p>
            All points of identification must be certified. To see who can certify documents read our <a href="https://www.casa.gov.au/licences-and-certificates/aviation-reference-numbers/certifying-your-identity-documents" target="_blank" rel='noreferrer'>certifying your identity documents page.</a>
        </p>
      </AuFormItemWrapper>

      <FormNavigation
        nextButtonText='Next'
        onNextAction={handleNext}
        hidePrevious
        showSaveAndExit={false} />
    </>
  );
};

export default ManualPOIInformation;